/* ═══ שריון טעינה כפולה ═══
   אם הסקשן קיים פעמיים בעמוד (למשל בלוק ישן ששכח להימחק), הסקריפט
   נטען ומורץ פעמיים — האזנות כפולות הופכות כל טוגל (השתקה, סגירה)
   לפעולה שמבטלת את עצמה. ההרצה השנייה נחסמת כאן. */
if (!window.__IDS_UGC_BOOTED) { window.__IDS_UGC_BOOTED = true;

/* ===== Inner Dragon · As Seen On (UGC Videos) · JS v6 =====
 * v6: נקודות התקדמות בנגן (סטייל סטוריז) — רואים כמה סרטונים יש
 * ואיפה נמצאים; חיווי הסוויפ במובייל נשאר ~9 שניות במקום ~4.5.
 * v5.1 (מעקב ייחוס): קריאות ל-window.IDSUgcTrack (ids-ugc-tracking.js)
 * בשלושה רגעים — צפייה בסרטון בנגן ('view'), לחיצה על כרטיס מוצר
 * בנגן ('card_click'), והוספה לסל מוצלחת מתוך הנגן ('atc').
 * הייחוס נשמר כמאפייני עגלה ועובר אוטומטית להזמנה. אם מודול
 * המעקב לא נטען — הכל ממשיך לעבוד רגיל (הקריאות מוגנות).
 * v5 (תיקון באג in-app): ב-WebView מוטמע של טיקטוק/אינסטגרם/פייסבוק
 * playsinline לא תמיד מכובד, וכל video.play() אוטומטי נחטף לנגן
 * fullscreen מקורי שחוסם את העמוד ומונע השלמת רכישה. בדפדפנים האלה
 * מכבים את הניגון האוטומטי של הרצועה בלבד — הממוזערים נשארים עם
 * פוסטר, ולחיצה עדיין פותחת את הנגן כרגיל. כרום/ספארי לא מושפעים.
 * Startup 2026-09-19: adaptive 720-line target within the connection budget,
 * on-intent loading, selected video first, one bounded neighbor warm-up.
 * Older Safari/in-app browsers keep native playback and sound recovery.
 * v3: רצועת הממוזערים בניגון מתחלף (round-robin) — במקום שכל
 * הסרטונים ינגנו יחד (מסיח דעת), רק אחד מתנגן בכל רגע ~3 שניות
 * ואז עובר לבא בתור מבין הנראים על המסך. נעצר כשהנגן המלא פתוח.
 * v2: הנגן מטולפרט ל-body בזמן האתחול — transform על סקשנים של
 * התבנית שבר את ה-position:fixed והנגן נתקע בתוך העמוד בלי X נראה.
 * תחליף עצמי ל-Tolstoy, בלי ספריות, ~7KB.
 *
 * רצועה: הווידאו ברזולוציה נמוכה נטען ומתנגן (מושתק) רק כשהממוזער
 * נראה על המסך, אחד-אחד בסבב. נגן: פיד אנכי בהחלקה (scroll-snap).
 * נטענים רק הסרטון הנוכחי ושכניו. סאונד נפתח ברגע הלחיצה (מחווה).
 * קנייה: טאפ על מידה בכרטיס = הוספה לסל בסיבוב רשת אחד
 * (Bundled Section Rendering) — תוכן העגלה מוחלף בשקט; העגלה
 * נפתחת רק כשסוגרים את הנגן, כדי לא לקטוע את הצפייה.
 */
(function () {
  'use strict';

  /* ───────── זיהוי דפדפן מוטמע (in-app) ─────────
     ב-WebView של טיקטוק/אינסטגרם/פייסבוק, playsinline לא תמיד מכובד,
     וכל video.play() אוטומטי נחטף לנגן fullscreen מקורי שחוסם את
     העמוד ומונע השלמת רכישה. בדפדפנים האלה מכבים את הניגון האוטומטי
     של הרצועה בלבד — הממוזערים נשארים עם תמונת פוסטר, ולחיצה עדיין
     פותחת את הנגן כרגיל. כרום/ספארי רגילים לא מושפעים. */
  var IS_INAPP = (function () {
    var ua = (navigator.userAgent || '').toLowerCase();
    return /tiktok|musical_ly|bytedance|bytelo|instagram|fb_iab|fbav|fban|fbios|messenger|\bline\/|snapchat|pinterest/.test(ua);
  })();

  /* ───────── עזרים ───────── */

  function getCartDrawer() {
    return document.querySelector('cart-drawer[data-section-id]');
  }

  function swapCartDrawer(html) {
    var current = getCartDrawer();
    if (!current || !html) return false;
    var tmp = new DOMParser().parseFromString(html, 'text/html');
    var fresh = tmp.querySelector('cart-drawer');
    if (!fresh) return false;
    var freshContent = fresh.querySelector('.drawer__content');
    var curContent = current.querySelector('.drawer__content');
    if (freshContent && curContent) curContent.innerHTML = freshContent.innerHTML;
    else current.innerHTML = fresh.innerHTML;
    return true;
  }

  function syncHeaderSoft() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var d = getCartDrawer();
        ['.cart-count', '.cart-count-bubble', '[data-cart-count]', '.cart__count'
        ].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            if (d && d.contains(el)) return;
            el.textContent = cart.item_count;
            if (cart.item_count > 0) el.removeAttribute('hidden');
          });
        });
        if (cart.item_count > 0) document.documentElement.classList.add('cart-has-items');
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true, detail: { cart: cart, source: 'ids-ugc' }
        }));
      })
      .catch(function () {});
  }

  var toastEl = null;
  var toastTimer = null;
  function toast(text) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ids-ugc__toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);
  }

  /* ───────── מעקב ייחוס (ids-ugc-tracking.js) ─────────
     קריאות מוגנות — אם מודול המעקב לא נטען, שום דבר לא נשבר. */

  function track(type, data) {
    if (window.IDSUgcTrack) {
      try { window.IDSUgcTrack.record(type, data); } catch (e) {}
    }
  }

  /* שולף handle של מוצר מתוך קישור /products/<handle> */
  function handleFromHref(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    return m ? m[1] : '';
  }

  /* מזהה סרטון/מוצר מתוך סלייד בנגן: ה-handle של המוצר הראשון
     בכרטיסי "shop the look", ואם אין — האינדקס של הסלייד. */
  function slideTrackInfo(slide) {
    if (!slide) return { video: '', product: '' };
    var a = slide.querySelector('.ids-ugc__shop a[href]');
    var handle = a ? handleFromHref(a.getAttribute('href')) : '';
    var player = slide.closest('[data-ids-ugc-player]');
    var idx = player ? slidesOf(player).indexOf(slide) : -1;
    return { video: handle || ('video-' + (idx + 1)), product: handle };
  }

  /* ───────── רצועת הממוזערים — ניגון מתחלף (round-robin) ─────────
     רק סרטון אחד מתנגן בכל רגע, ~3 שניות, ואז עובר לבא בתור מבין
     הנראים על המסך. זה מושך את העין ומפתה ללחוץ על סרטון אחר. */

  var STRIP_PLAY_MS = 3000;   /* משך ניגון לכל סרטון לפני המעבר */
  var stripVisible = [];      /* הממוזערים הנראים כרגע, לפי סדר DOM */
  var stripPos = 0;
  var stripTimer = null;

  function stripVid(thumb) {
    return thumb ? thumb.querySelector('video') : null;
  }

  function playerIsOpen() {
    return !!document.querySelector('[data-ids-ugc-player]:not([hidden])');
  }

  function stripPauseAll() {
    document.querySelectorAll('[data-ids-ugc-open] video').forEach(function (v) {
      if (!v.paused) v.pause();
      v.classList.remove('is-playing');
    });
  }

  /* מנגן ממוזער אחד ומכבה את כל היתר */
  function stripPlayOnly(thumb) {
    if (IS_INAPP) return;   /* in-app: בלי ניגון אוטומטי שנחטף ל-fullscreen */
    var target = stripVid(thumb);
    document.querySelectorAll('[data-ids-ugc-open] video').forEach(function (v) {
      if (v !== target) { v.pause(); v.classList.remove('is-playing'); }
    });
    if (!target) return;
    if (!target.src) target.src = target.getAttribute('data-src');
    target.play().then(function () { target.classList.add('is-playing'); }).catch(function () {});
  }

  /* פעימת הסבב: מנגן את הנוכחי, מקדם את המצביע, ומתזמן את הבא */
  function stripTick() {
    if (IS_INAPP || playerIsOpen() || stripVisible.length === 0) return;
    if (stripPos >= stripVisible.length) stripPos = 0;
    var thumb = stripVisible[stripPos];
    var v = stripVid(thumb);
    if (v) { try { v.currentTime = 0; } catch (e) {} }
    stripPlayOnly(thumb);
    stripPos++;
    stripTimer = setTimeout(stripTick, STRIP_PLAY_MS);
  }

  /* נקרא בכל שינוי בקבוצת הנראים — מאתחל את הסבב מחדש */
  function stripRefresh() {
    clearTimeout(stripTimer);
    stripTimer = null;
    if (IS_INAPP || playerIsOpen() || stripVisible.length === 0) {
      if (stripVisible.length === 0) stripPauseAll();
      return;
    }
    if (stripVisible.length === 1) {
      stripPlayOnly(stripVisible[0]); /* ממוזער יחיד נראה — מתנגן בלולאה */
      return;
    }
    stripPos = 0;
    stripTick();
  }

  var stripIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var thumb = entry.target;
      var inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
      var at = stripVisible.indexOf(thumb);
      if (inView && at === -1) {
        stripVisible.push(thumb);
      } else if (!inView && at !== -1) {
        stripVisible.splice(at, 1);
        var v = stripVid(thumb);
        if (v) { v.pause(); v.classList.remove('is-playing'); }
      }
    });
    /* שמירה על סדר התצוגה לפי ה-DOM */
    stripVisible.sort(function (a, b) {
      return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    });
    stripRefresh();
  }, { threshold: [0, 0.5] });

  function initSection(root) {
    if (root.getAttribute('data-ids-ugc-ready') === '1') return;
    root.setAttribute('data-ids-ugc-ready', '1');

   /* רצועה: ניגון מתחלף (round-robin) — סרטון אחד בכל רגע, ~3 שניות,
       בדסקטופ ובמובייל כאחד. במובייל זה קל: רק ממוזער אחד מתנגן
       (מושתק) בכל פעם, לא כל הסרטונים יחד — אז הגלילה לא נפגעת. */
    root.querySelectorAll('[data-ids-ugc-open]').forEach(function (thumb) {
      if (root.getAttribute('data-ids-ugc-autoplay') !== 'false') stripIO.observe(thumb);
    });

    /* טלפורט הנגן ל-body: לסקשנים של התבנית יש transform (אנימציות),
       ו-transform על אב שובר position:fixed — הנגן נתקע בתוך העמוד.
       מחוץ לסקשן הוא שכבה צפה אמיתית על כל המסך. */
    var owner = root.closest('.shopify-section') ? root.closest('.shopify-section').id : 'ids-ugc';
    var player = root.querySelector('[data-ids-ugc-player]');
    if (player) {
      document.querySelectorAll('body > [data-ids-ugc-player][data-ids-ugc-owner="' + owner + '"]')
        .forEach(function (stale) { stale.querySelectorAll("video").forEach(disposeVideo); stale.remove(); });
      player.setAttribute('data-ids-ugc-owner', owner);
      root.setAttribute('data-ids-ugc-owner-id', owner);
      document.body.appendChild(player);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ids-ugc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);

  /* ───────── הנגן ───────── */

  var state = { muted: false, added: false, busy: false };

  function playerOf(el) {
    var root = el.closest('[data-ids-ugc]');
    if (!root) return null;
    var inRoot = root.querySelector('[data-ids-ugc-player]');
    if (inRoot) return inRoot; /* טרם טולפרט (גיבוי) */
    var owner = root.getAttribute('data-ids-ugc-owner-id');
    return owner
      ? document.querySelector('[data-ids-ugc-player][data-ids-ugc-owner="' + owner + '"]')
      : document.querySelector('[data-ids-ugc-player]');
  }

  function slidesOf(player) {
    return Array.prototype.slice.call(player.querySelectorAll('[data-ids-ugc-slide]'));
  }

  /* UGC startup: one selected stream, one bounded warm-up, adaptive quality.
     HLS.js is self-hosted and loaded only on intent. Native HLS remains the
     fallback for older Safari and embedded browsers. */
  var ugcHlsPromise = null;
  var ugcWarmVideo = null;
  var ugcBandwidth = 0;
  var ugcBandwidthAt = 0;

  function connectionHint() {
    return navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
  }

  function limitedConnection() {
    var c = connectionHint();
    return !!c.saveData || /(^|-)2g$|^3g$/.test(c.effectiveType || '') || (c.downlink > 0 && c.downlink < 1.5);
  }

  function startupLevel(levels) {
    if (limitedConnection()) return 0;
    var c = connectionHint();
    var estimate = Date.now() - ugcBandwidthAt < 30000 ? ugcBandwidth : 0;
    if (!estimate && c.downlink > 0) estimate = c.downlink * 1000000;
    // Unknown connections get a moderate budget, not a forced lowest-level probe.
    var budget = estimate ? estimate * 0.75 : 4000000;
    var selected = 0;
    levels.forEach(function (level, index) {
      var edge = Math.max(level.width || 0, level.height || 0);
      var rate = level.averageBitrate || level.bitrate || 0;
      if (edge <= 720 && rate <= budget) selected = index;
    });
    return selected;
  }

  function loadUgcHls(player) {
    if (IS_INAPP || !(window.MediaSource || window.ManagedMediaSource || window.WebKitMediaSource)) return Promise.resolve(null);
    if (window.IDSUgcHls && window.IDSUgcHls.isSupported()) return Promise.resolve(window.IDSUgcHls);
    if (ugcHlsPromise) return ugcHlsPromise;
    var url = player.getAttribute('data-ids-ugc-hls-src');
    if (!url) return Promise.resolve(null);
    ugcHlsPromise = new Promise(function (resolve) {
      var script = document.createElement('script');
      var done = false;
      var timer = setTimeout(function () { finish(null); }, 4000);
      function finish(Hls) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(Hls && Hls.isSupported() ? Hls : null);
      }
      script.src = url;
      script.async = true;
      script.onload = function () { finish(window.IDSUgcHls); };
      script.onerror = function () { finish(null); };
      document.head.appendChild(script);
    });
    return ugcHlsPromise;
  }

  function bufferedAhead(v) {
    for (var i = 0; i < v.buffered.length; i++) {
      if (v.buffered.start(i) <= v.currentTime + 0.1 && v.buffered.end(i) > v.currentTime) return v.buffered.end(i) - v.currentTime;
    }
    return 0;
  }

  function isCurrentVideo(v) {
    var m = v.__idsMedia;
    return !!m && !m.disposed && !m.player.hasAttribute('hidden') && m.player.__idsActiveSlide === m.slide;
  }

  function stopWarmVideo(except) {
    if (ugcWarmVideo && ugcWarmVideo !== except) disposeVideo(ugcWarmVideo);
    ugcWarmVideo = null;
  }

  function disposeVideo(v) {
    var m = v.__idsMedia;
    if (!m || m.disposed) return;
    m.disposed = true;
    clearTimeout(m.expiry);
    if (m.hls) m.hls.destroy();
    v.pause();
    v.removeAttribute('src');
    try { v.load(); } catch (e) {}
    if (m.poster) m.poster.remove();
    m.holder.removeAttribute('data-ids-ugc-ready');
    v.remove();
    if (ugcWarmVideo === v) ugcWarmVideo = null;
  }

  function pauseAll(player, except) {
    player.querySelectorAll('video').forEach(function (v) {
      if (v === except) return;
      v.pause();
      v.preload = 'none';
      var m = v.__idsMedia;
      if (m) { m.mode = 'paused'; m.loading = false; if (m.hls) m.hls.stopLoad(); }
    });
  }

  function attemptPlayback(v) {
    if (!isCurrentVideo(v)) return;
    v.play().catch(function (error) {
      if (!isCurrentVideo(v) || error.name !== 'NotAllowedError') return;
      // Preserve the existing per-element iOS sound recovery, without treating
      // source attachment/AbortError as a request to mute the customer.
      v.muted = true;
      v.__idsMedia.player.setAttribute('data-muted', '1');
      v.play().catch(function () {});
      armUnmuteOnGesture(v.__idsMedia.player);
    });
  }

  function resumeMedia(v) {
    var m = v.__idsMedia;
    if (!m || m.disposed || m.mode === 'paused') return;
    v.preload = m.mode === 'active' ? 'auto' : 'metadata';
    if (m.hls && m.manifest && !m.loading) {
      m.loading = true;
      m.hls.config.maxBufferLength = m.mode === 'active' ? 10 : 2;
      m.hls.config.maxMaxBufferLength = m.mode === 'active' ? 14 : 2;
      m.hls.startLoad(v.currentTime || -1);
    }
    if (m.mode === 'active' && m.attached) attemptPlayback(v);
  }

  function fallbackMedia(v) {
    var m = v.__idsMedia;
    if (!m || m.disposed || m.fallback) return;
    m.fallback = true;
    var time = v.currentTime || 0;
    if (m.hls) { m.hls.destroy(); m.hls = null; }
    v.disableRemotePlayback = false;
    var hls = m.slide.getAttribute('data-video-hls');
    var source = hls && v.canPlayType('application/vnd.apple.mpegurl') ? hls : m.slide.getAttribute(limitedConnection() ? 'data-video-low' : 'data-video-src');
    source = source || m.slide.getAttribute('data-video-src');
    m.attached = true;
    m.holder.removeAttribute('data-ids-ugc-ready');
    m.slide.setAttribute('data-ids-ugc-engine', hls && source === hls ? 'native-hls' : 'mp4');
    if (time) v.addEventListener('loadedmetadata', function restorePosition() {
      v.removeEventListener('loadedmetadata', restorePosition);
      if (!m.disposed) { try { v.currentTime = time; } catch (e) {} }
    });
    v.preload = m.mode === 'active' ? 'auto' : 'metadata';
    v.src = source || '';
    if (m.mode === 'active') attemptPlayback(v);
  }

  function attachAdaptiveMedia(v) {
    var m = v.__idsMedia;
    var url = m.slide.getAttribute('data-video-hls');
    if (!url || IS_INAPP || (limitedConnection() && v.canPlayType('application/vnd.apple.mpegurl')) || !(window.MediaSource || window.ManagedMediaSource || window.WebKitMediaSource)) { fallbackMedia(v); return; }
    loadUgcHls(m.player).then(function (Hls) {
      if (m.disposed) return;
      if (!Hls) { fallbackMedia(v); return; }
      var hls;
      try {
        hls = new Hls({ autoStartLoad: false, enableWorker: true, preferManagedMediaSource: true,
          lowLatencyMode: false, backBufferLength: 6, maxBufferLength: 10,
          maxMaxBufferLength: 14, maxBufferSize: 8000000, maxStarvationDelay: 2, maxLoadingDelay: 2 });
        m.hls = hls;
        // Required for ManagedMediaSource on iPhone; native fallback restores it.
        v.disableRemotePlayback = true;
        m.slide.setAttribute('data-ids-ugc-engine', 'adaptive-hls');
        hls.on(Hls.Events.MEDIA_ATTACHED, function () {
          if (m.disposed) return;
          m.attached = true;
          hls.loadSource(url);
          if (m.mode === 'active') attemptPlayback(v);
        });
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          if (m.disposed) return;
          m.manifest = true;
          hls.startLevel = startupLevel(hls.levels);
          if (connectionHint().saveData) hls.autoLevelCapping = 0;
          m.slide.setAttribute('data-ids-ugc-start-level', String(hls.startLevel));
          resumeMedia(v);
        });
        hls.on(Hls.Events.FRAG_BUFFERED, function () {
          if (m.disposed) return;
          if (isCurrentVideo(v) && hls.bandwidthEstimate > 0) { ugcBandwidth = hls.bandwidthEstimate; ugcBandwidthAt = Date.now(); }
          if (m.mode !== 'active') { hls.stopLoad(); m.loading = false; }
          warmNextWhenReady(v);
        });
        hls.on(Hls.Events.ERROR, function (_, data) {
          if (data.fatal) fallbackMedia(v);
        });
        hls.attachMedia(v);
      } catch (e) { fallbackMedia(v); }
    });
  }

  function warmNextWhenReady(v) {
    if (!isCurrentVideo(v) || v.paused || v.readyState < 3 || bufferedAhead(v) < 5 || limitedConnection() || document.hidden) return;
    var player = v.__idsMedia.player;
    if (player.classList.contains('ids-ugc--pip')) return;
    var slides = slidesOf(player);
    var next = slides[slides.indexOf(v.__idsMedia.slide) + 1];
    if (next && next.querySelector('[data-ids-ugc-holder]') && player.__idsWarmedFrom !== v) {
      player.__idsWarmedFrom = v;
      warmSlide(next, true);
    }
  }

  function warmSlide(slide, keepForNext) {
    if (limitedConnection()) return;
    var existing = slide.querySelector('[data-ids-ugc-holder] video');
    if (existing) return; // Reuse a cached stream; never reset it with load().
    stopWarmVideo(null);
    var v = ensureVideo(slide, false);
    if (!v) return;
    ugcWarmVideo = v;
    if (!keepForNext) v.__idsMedia.expiry = setTimeout(function () { if (!isCurrentVideo(v)) disposeVideo(v); }, 12000);
  }

  function ensureVideo(slide, eager) {
    var holder = slide.querySelector('[data-ids-ugc-holder]');
    if (!holder) return null;
    var v = holder.querySelector('video');
    if (!v) {
      v = document.createElement('video');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.preload = eager ? 'auto' : 'metadata';
      v.poster = slide.getAttribute('data-poster') || '';
      var poster = document.createElement('img');
      poster.className = 'ids-ugc__poster';
      poster.alt = '';
      poster.decoding = 'async';
      if (v.poster) poster.src = v.poster;
      holder.appendChild(poster);
      holder.appendChild(v);
      var m = v.__idsMedia = { slide: slide, player: slide.closest('[data-ids-ugc-player]'), holder: holder,
        poster: poster, mode: eager ? 'active' : 'warm', disposed: false, loading: false };
      v.addEventListener('playing', function () {
        var reveal = function () { if (!m.disposed) holder.setAttribute('data-ids-ugc-ready', ''); };
        if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(reveal); else reveal();
        warmNextWhenReady(v);
      });
      v.addEventListener('progress', function () { warmNextWhenReady(v); });
      v.addEventListener('timeupdate', function () { warmNextWhenReady(v); });
      v.addEventListener('waiting', function () { if (isCurrentVideo(v)) stopWarmVideo(v); });
      v.addEventListener('click', function () {
        if (Date.now() - (window.__idsUgcDragTs || 0) < 350) return;
        if (v.paused) attemptPlayback(v); else { v.pause(); stopWarmVideo(v); }
      });
      attachAdaptiveMedia(v);
    }
    if (eager) {
      var media = v.__idsMedia;
      clearTimeout(media.expiry);
      if (ugcWarmVideo === v) ugcWarmVideo = null;
      media.mode = 'active';
      v.preload = 'auto';
      if (media.hls) media.loading = false;
      resumeMedia(v);
    }
    return v;
  }


  /* ───────── שמירת הסאונד לאורך הפיד ─────────
     דפדפנים מרשים סאונד רק לווידאו שהופעל מתוך מחווה של המשתמשת,
     וההרשאה היא פר-אלמנט. כל סלייד הוא <video> נפרד, והחלקה נחשבת
     גלילה — לא מחווה — אז אחרי סרטון-שניים ניגון עם סאונד נדחה.
     1) הכשרה (priming): כל נגיעה בנגן היא מחווה אמיתית — מפעילים־
        ועוצרים בשקט את סרטוני השכנים. אלמנט שהופעל מתוך מחווה
        רשאי להתנגן עם סאונד גם בהמשך.
     2) רשת ביטחון: אם ניגון עם סאונד בכל זאת נדחה, הסלייד מתנגן
        מושתק והמגע הבא מחזיר את הסאונד — בלי לנעול את כל הנגן. */

  var primeTs = 0;
  function primeNeighbors(player) {
    if (IS_INAPP || limitedConnection()) return;
    var current = player.__idsActiveSlide && player.__idsActiveSlide.querySelector('video');
    if (!current || current.paused || bufferedAhead(current) < 5) return;
    /* ריסון: הכשרה לכל היותר פעם ב-700ms ורק לשכנים המיידיים —
       בלי לחנוק את ה-main thread באמצע מחוות גלילה (גרם לתקיעות) */
    var now = Date.now();
    if (now - primeTs < 700) return;
    primeTs = now;
    var feed = player.querySelector('[data-ids-ugc-feed]');
    if (!feed) return;
    var slides = slidesOf(player);
    var idx = Math.round(feed.scrollTop / Math.max(1, feed.clientHeight));
    [idx - 1, idx + 1].forEach(function (i) {
      var s = slides[i];
      if (!s) return;
      var v = s.querySelector('video');
      if (!v || v.readyState < 2 || v.__idsPrimed || !v.paused) return;
      v.__idsPrimed = true;
      v.__idsPrimeCancel = false;
      var wasMuted = v.muted;
      v.muted = true;
      var pr = v.play();
      if (pr && pr.then) {
        pr.then(function () {
          /* מרוץ: אם בינתיים החליקה לסרטון הזה — הוא פעיל, לא עוצרים */
          if (v.__idsPrimeCancel) return;
          v.pause();
          v.muted = wasMuted;
        }).catch(function () {
          if (v.__idsPrimeCancel) return;
          v.__idsPrimed = false;
          v.muted = wasMuted;
        });
      }
    });
  }

  function armUnmuteOnGesture(player) {
    if (player.__idsUnmuteArmed) return;
    player.__idsUnmuteArmed = true;
    var restore = function (ev) {
      /* מגע שמתחיל על כפתור ההשתקה — הכפתור מחליט בעצמו, לא אנחנו.
         בלי זה הלחיצה עליו מתבטלת: ה-pointerdown מחזיר סאונד
         וה-click של הכפתור משתיק מיד בחזרה — נראה כאילו מת. */
      if (ev && ev.target && ev.target.closest && ev.target.closest('[data-ids-ugc-mute]')) return;
      player.__idsUnmuteArmed = false;
      player.removeEventListener('touchstart', restore, true);
      player.removeEventListener('pointerdown', restore, true);
      if (state.muted) return; /* היא בחרה השתקה בעצמה — מכבדים */
      player.querySelectorAll('video').forEach(function (v) {
        if (!v.paused) v.muted = false;
      });
      player.setAttribute('data-muted', '0');
    };
    player.addEventListener('touchstart', restore, true);
    player.addEventListener('pointerdown', restore, true);
  }

  function playSlide(player, slide) {
    if (player.hasAttribute('hidden')) return;
    var existing = slide.querySelector('video');
    if (player.__idsActiveSlide === slide && existing && !existing.paused) return;
    player.__idsActiveSlide = slide;
    stopWarmVideo(existing);
    pauseAll(player, existing);
    var v = ensureVideo(slide, true);
    var slides = slidesOf(player), index = slides.indexOf(slide);
    slides.forEach(function (other, i) {
      if (Math.abs(i - index) > 1) other.querySelectorAll('video').forEach(disposeVideo);
    });
    if (v) v.__idsPrimeCancel = true; /* פעיל — ההכשרה ברקע לא תעצור אותו */
    if (!v) {
      /* סלייד בלי וידאו (סלייד הסיכום) — משתיק את כל השאר */
      pauseAll(player, null);
      try { document.dispatchEvent(new CustomEvent('ids-ugc:slide', { detail: { slide: slide, player: player } })); } catch (e3) {}
      return;
    }
    pauseAll(player, v);
    /* מעקב ייחוס: צפייה בסרטון (דדופ לכל סרטון בכל סשן במודול המעקב) */
    track('view', slideTrackInfo(slide));
    v.muted = state.muted;
    player.setAttribute('data-muted', state.muted ? '1' : '0');
    attemptPlayback(v);
    /* אירוע פנימי: סלייד הופעל — מודול ה-upsell מסמן "כבר בסל"
       על מוצרים שכבר נוספו ומדלג ישר ל-upsell במקום כפילויות */
    try { document.dispatchEvent(new CustomEvent('ids-ugc:slide', { detail: { slide: slide, player: player } })); } catch (e2) {}
  }

  var feedIO = null;

  function watchFeed(player) {
    if (player.getAttribute('data-feed-ready') === '1') return;
    player.setAttribute('data-feed-ready', '1');
    var feed = player.querySelector('[data-ids-ugc-feed]');
    feedIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!player.hasAttribute('hidden') && !player.classList.contains('ids-ugc--pip') && entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          playSlide(player, entry.target);
        }
      });
    }, { root: feed, threshold: [0.6] });
    slidesOf(player).forEach(function (s) { feedIO.observe(s); });

    /* הכשרת סרטוני השכנים בכל מחווה אמיתית — הסאונד שורד החלקות */
    player.addEventListener('touchstart', function () { primeNeighbors(player); }, { passive: true, capture: true });
    player.addEventListener('pointerdown', function () { primeNeighbors(player); }, { passive: true, capture: true });

    /* פיד אינסופי: מתקרבים לסוף → טוענים את המוצר הבא מהתור */
    feed.addEventListener('scroll', function () {
      var slides = slidesOf(player);
      var idx = Math.round(feed.scrollTop / Math.max(1, feed.clientHeight));
      if (slides.length - idx <= 2) appendQueuedSlides(player);
    }, { passive: true });

    /* דסקטופ: גלגלת עכבר = מעבר סרטון שלם — על כל שכבת הנגן,
       כולל הרקע המטושטש (הסמן לרוב מחוץ לכרטיס הצר). בלי זה,
       snap-mandatory "מחזיר" כל תנועת גלגלת קטנה לאותו סרטון. */
    var wheelLock = false;
    player.addEventListener('wheel', function (ev) {
      ev.preventDefault();
      /* מעל כרטיסי המוצרים: הגלגלת גוללת אותם הצידה, לא מחליפה סרטון */
      var shop = ev.target.closest ? ev.target.closest('.ids-ugc__shop') : null;
      if (shop) {
        shop.scrollBy({ left: (ev.deltaY || ev.deltaX) });
        return;
      }
      if (wheelLock) return;
      if (Math.abs(ev.deltaY) < 8) return;
      wheelLock = true;
      stepSlide(player, ev.deltaY > 0 ? 1 : -1);
      setTimeout(function () { wheelLock = false; }, 500);
    }, { passive: false });

    /* דסקטופ: סוויפ בעכבר — אנכי בכל מקום = מעבר סרטון;
       אופקי על כרטיסי המוצרים = גרירת הכרטיסים כמו אצבע */
    var dragY = null, dragX = null, dragShop = null, shopMoved = false;
    player.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      dragY = ev.clientY;
      dragX = ev.clientX;
      dragShop = ev.target.closest ? ev.target.closest('.ids-ugc__shop') : null;
      shopMoved = false;
    });
    player.addEventListener('pointermove', function (ev) {
      if (ev.pointerType !== 'mouse' || dragY === null || !dragShop) return;
      var dx = ev.clientX - dragX;
      if (Math.abs(dx) > 2) {
        dragShop.scrollBy({ left: -dx });
        dragX = ev.clientX;
        shopMoved = true;
        window.__idsUgcDragTs = Date.now();
      }
    });
    player.addEventListener('pointerup', function (ev) {
      if (ev.pointerType !== 'mouse' || dragY === null) return;
      var d = ev.clientY - dragY;
      var wasShopDrag = dragShop && shopMoved;
      dragY = null; dragX = null; dragShop = null; shopMoved = false;
      if (wasShopDrag) return; /* גרירת כרטיסים — לא מעבר סרטון */
      if (Math.abs(d) > 60) {
        window.__idsUgcDragTs = Date.now();
        stepSlide(player, d < 0 ? 1 : -1);
      }
    });
  }

  function openPlayer(player, index) {
    state.added = false;
    state.muted = false;
    player.removeAttribute('hidden');
    document.documentElement.classList.add('ids-ugc-lock');
    /* עוצרים את סבב הרצועה בזמן שהנגן המלא פתוח */
    clearTimeout(stripTimer);
    stripTimer = null;
    stripPauseAll();
    watchFeed(player);
    /* אינדקסי הממוזערים מפנים לסליידים המקוריים בלבד — סלייד
       upsell שהוזרק באמצע לא מזיז את המיפוי */
    var slides = slidesOf(player).filter(function (s) {
      return !s.hasAttribute('data-ids-ugc-injected');
    });
    var target = slides[index] || slides[0];
    if (!target) return;
    /* קפיצה מיידית לסרטון שנבחר, בלי אנימציית גלילה */
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
    playSlide(player, target);
    /* פיד קצר (מוצר עם סרטון-שניים)? מתחילים למלא מהתור מיד */
    if (slidesOf(player).length < 3) appendQueuedSlides(player);
  }

  function openDrawerIfAdded() {
    if (!state.added) return;
    /* התוכן כבר הוחלף בזמן ההוספה — רק פותחים */
    var d = getCartDrawer();
    if (d && !d.hasAttribute('open') && typeof d.show === 'function') {
      try { d.show(); } catch (e) {}
    }
    state.added = false;
  }

  function reallyClose(player) {
    player.classList.remove('ids-ugc--pip');
    player.setAttribute('hidden', '');
    document.documentElement.classList.remove('ids-ugc-lock');
    player.__idsActiveSlide = null;
    player.__idsWarmedFrom = null;
    player.querySelectorAll('video').forEach(disposeVideo);
    openDrawerIfAdded();
    /* מחזירים את סבב הרצועה לפעולה */
    stripRefresh();
  }

  /* ───────── בועת נגן צפה (PiP) ─────────
     סגירת הנגן לא מעלימה אותו — הוא מתכווץ לבועה קטנה בפינת
     המסך שממשיכה לנגן מושתקת (נגן צף ממיר משמעותית יותר מרצועה
     מוטמעת). טאפ על הבועה = חזרה לנגן מלא; ✕ = סגירה סופית,
     נשמר לכל הסשן כדי לא להציק. */

  function pipOff() {
    try { return sessionStorage.getItem('idsUgcPipOff') === '1'; } catch (e) { return false; }
  }

  function ensurePipX(player) {
    var stage = player.querySelector('.ids-ugc__stage');
    if (!stage || stage.querySelector('[data-ids-ugc-pipx]')) return;
    var x = document.createElement('button');
    x.type = 'button';
    x.setAttribute('data-ids-ugc-pipx', '');
    x.setAttribute('aria-label', 'סגירת הבועה');
    x.innerHTML = '&#10005;';
    stage.appendChild(x);
  }

  function enterPip(player) {
    var playing = null;
    player.querySelectorAll('video').forEach(function (v) { if (!v.paused) playing = v; });
    if (!playing) return false; /* אין מה להציג בבועה */
    document.documentElement.classList.remove('ids-ugc-lock');
    player.classList.add('ids-ugc--pip');
    var st = player.querySelector('.ids-ugc__stage');
    var stw = st ? st.getBoundingClientRect().width : 0;
    if (!st || stw > 140) {
      /* ה-CSS של הבועה לא פעיל — נסיגה לסגירה רגילה */
      player.classList.remove('ids-ugc--pip');
      return false;
    }
    stopWarmVideo(playing);
    playing.muted = true;
    player.setAttribute('data-muted', '1');
    ensurePipX(player);
    return true;
  }

  function closePlayer(player) {
    /* הוסיפה לסל? סגירה מלאה — הסל נפתח ואסור שהבועה תשב עליו */
    if (!state.added && !pipOff() && enterPip(player)) return;
    reallyClose(player);
  }

  function stepSlide(player, dir) {
    var feed = player.querySelector('[data-ids-ugc-feed]');
    if (!feed) return;
    feed.scrollBy({ top: dir * feed.clientHeight, behavior: 'smooth' });
  }

  /* Newly inserted slides share the selected-stream-first warm-up budget. */
  window.__idsUgcObserveSlide = function (sl) {
    if (!sl) return;
    if (feedIO) feedIO.observe(sl);
    var player = sl.closest('[data-ids-ugc-player]');
    var current = player && player.__idsActiveSlide && player.__idsActiveSlide.querySelector('video');
    if (current) { player.__idsWarmedFrom = null; warmNextWhenReady(current); }
  };

  /* הפעלה מפורשת של סלייד — עצירת כל השאר + ניגון. הגלייד של
     ה-upsell קורא לזה בהגעה, כדי שהסאונד יתחלף בוודאות גם אם
     ה-IntersectionObserver לא ירה (נצפה במובייל). */
  window.__idsUgcActivateSlide = function (sl) {
    if (!sl) return;
    var p = sl.closest('[data-ids-ugc-player]');
    if (p) playSlide(p, sl);
  };

  /* ───────── פיד אינסופי — כמו טיקטוק, אבל כל סרטון מוכר ─────────
     כשמתקרבים לסוף הפיד נטען המוצר הבא מהתור (מוצרים משלימים +
     נמכרים ביותר, שהסקשן חישב ב-data-ids-ugc-queue) דרך Section
     Rendering API — בלי משקל על טעינת העמוד. כל סרטון חדש מגיע
     עם כרטיס קנייה ו-upsell משלו. נגמר התור? סלייד "הסט שלך". */

  function escT(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function appendQueuedSlides(player) {
    if (player.__idsQBusy) return;
    var q = (player.getAttribute('data-ids-ugc-queue') || '').split(',').filter(Boolean);
    /* לא טוענים מוצר שכבר יש לו כרטיס בפיד */
    var have = {};
    player.querySelectorAll('.ids-ugc-card[data-handle]').forEach(function (c) {
      have[c.getAttribute('data-handle')] = 1;
    });
    var h = null;
    while (q.length) {
      var cand = q.shift();
      if (!have[cand]) { h = cand; break; }
    }
    player.setAttribute('data-ids-ugc-queue', q.join(','));
    if (!h) { maybeSummary(player); return; }
    var owner = player.getAttribute('data-ids-ugc-owner') || '';
    var sid = owner.replace(/^shopify-section-/, '');
    if (!sid) return;
    player.__idsQBusy = true;
    fetch('/products/' + h + '?section_id=' + encodeURIComponent(sid))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        player.__idsQBusy = false;
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var feed = player.querySelector('[data-ids-ugc-feed]');
        if (!feed) return;
        var added = 0;
        tmp.querySelectorAll('[data-ids-ugc-slide]').forEach(function (sl) {
          if (added >= 2) return; /* עד 2 סרטונים לכל מוצר — גיוון */
          var node = document.importNode(sl, true);
          node.setAttribute('data-ids-ugc-injected', '1');
          feed.appendChild(node);
          if (feedIO) feedIO.observe(node);
          if (player.__idsDots) player.__idsDots.appendChild(document.createElement('span'));
          added++;
        });
      })
      .catch(function () { player.__idsQBusy = false; });
  }

  /* ───────── השלמת הסט — הפיד מקבל כיוון ─────────
     כשמוסיפים פריט, המוצרים המשלימים שלו קופצים לראש התור.
     היחידה בפיד היא סרטון (רוב הסרטונים מתייגים 2+ מוצרים) —
     אנחנו רק בוחרים איזה סרטון יגיע קודם, ובתוכו מסמנים את
     הכרטיס הרלוונטי כדי שהעין תלך ישר אליו. */
  var wantedCmp = {};
  window.__idsUgcWanted = wantedCmp;

  window.__idsUgcWantCmp = function (player, handles) {
    if (!player || !handles || !handles.length) return;
    var q = (player.getAttribute('data-ids-ugc-queue') || '').split(',').filter(Boolean);
    var have = {};
    player.querySelectorAll('.ids-ugc-card[data-handle]').forEach(function (c) {
      have[c.getAttribute('data-handle')] = 1;
    });
    for (var i = handles.length - 1; i >= 0; i--) {
      var h = handles[i];
      if (!h) continue;
      wantedCmp[h] = 1;
      if (have[h]) continue; /* כבר בפיד — הסימון בכרטיס יעשה את העבודה */
      var at = q.indexOf(h);
      if (at !== -1) q.splice(at, 1);
      q.unshift(h); /* המשלים לראש התור */
    }
    player.setAttribute('data-ids-ugc-queue', q.join(','));
  };

  /* הסט הושלם — סלייד הסיכום נכנס כסלייד הבא, ברגע השיא.
     לא מחייב: אפשר להמשיך לגלול מתחתיו לעוד סרטונים. */
  window.__idsUgcSetDone = function (player, curSlide) {
    maybeSummary(player, curSlide);
  };

  /* סיכום "הסט שלך": אחרי השלמת סט — כסלייד הבא; אחרת בסוף התור */
  function maybeSummary(player, afterSlide) {
    if (player.__idsSummary) return;
    var addedMap = window.__idsUgcAdded || {};
    var keys = Object.keys(addedMap);
    if (!keys.length) return;
    player.__idsSummary = true;
    var feed = player.querySelector('[data-ids-ugc-feed]');
    if (!feed) return;
    var items = '';
    keys.forEach(function (h) {
      var it = addedMap[h] || {};
      items += '<div class="ids-ugc__sumitem">' +
        (it.img ? '<img src="' + escT(it.img) + '" alt="" loading="lazy">' : '') +
        '<div><p>' + escT(it.t) + '</p><span>' + (it.s ? 'מידה ' + escT(it.s.replace(' / ', ' · ')) + ' · ' : '') + 'בסל ✓</span></div></div>';
    });
    var sl = document.createElement('div');
    sl.className = 'ids-ugc__slide ids-ugc__summary';
    sl.setAttribute('data-ids-ugc-slide', '');
    sl.setAttribute('data-ids-ugc-injected', '1');
    sl.innerHTML =
      '<div class="ids-ugc__sumbox">' +
        '<p class="ids-ugc__sumhead">הסט שלך מוכן</p>' +
        items +
        '<button type="button" class="ids-ugc__sumcta" data-ids-ugc-finish>לצפייה בסל ולתשלום</button>' +
        '<span class="ids-ugc__sumscroll">או המשיכי לגלול לעוד השראה</span>' +
      '</div>';
    if (afterSlide && afterSlide.parentNode === feed) {
      feed.insertBefore(sl, afterSlide.nextSibling);
    } else {
      feed.appendChild(sl);
    }
    if (feedIO) feedIO.observe(sl);
    var dts = player.__idsDots;
    if (dts) {
      var nIdx = [].indexOf.call(player.querySelectorAll('[data-ids-ugc-slide]'), sl);
      dts.insertBefore(document.createElement('span'), dts.children[nIdx] || null);
    }
  }

  /* ───────── הוספה לסל מתוך הנגן ───────── */

  function addFromPlayer(btn) {
    if (state.busy) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    state.busy = true;

    /* מעקב ייחוס: נאסף עכשיו, נרשם רק אם ההוספה הצליחה */
    var trackInfo = (function () {
      var info = slideTrackInfo(btn.closest('[data-ids-ugc-slide]'));
      var card = btn.closest('.ids-ugc-card');
      var link = card ? card.querySelector('a[href]') : null;
      var h = link ? handleFromHref(link.getAttribute('href')) : '';
      if (h) info.product = h;
      return info;
    })();

    var isPill = btn.classList.contains('pcard-size-btn');
    if (isPill) btn.classList.add('success'); /* פידבק אופטימי */

    var cartEl = getCartDrawer();
    var sectionId = cartEl ? cartEl.getAttribute('data-section-id') : null;
    var payload = { id: parseInt(variantId, 10), quantity: 1 };
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = '/';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        return res.json();
      })
      .then(function (data) {
        if (sectionId && data && data.sections && data.sections[sectionId]) {
          swapCartDrawer(data.sections[sectionId]);
        }
        if (!isPill) {
          btn.classList.add('success');
          btn.textContent = '✓ בסל';
        }
        state.added = true;
        /* מעקב ייחוס: הוספה לסל מתוך הנגן הצליחה */
        track('atc', trackInfo);
        toast('✓ נוסף לסל');
        syncHeaderSoft();
        state.busy = false;
        /* אירוע פנימי — מנגנון ה-upsell צבע-אחות מאזין לו (רץ
           סינכרונית). אם הוא מתזמן מעבר לסרטון אחר, הוא מסמן
           __idsSkipAdv על הרצועה — והקידום האופקי מוותר, כדי
           שלא יהיו שתי גלילות מתנגשות ("מריץ קדימה הצידה"). */
        try { document.dispatchEvent(new CustomEvent('ids-ugc:atc', { detail: { btn: btn } })); } catch (err) {}
        /* מעבר אוטומטי לכרטיס המוצר הבא בסרטון — רגע של ✓ ואז
           הרצועה מחליקה לבד. scrollIntoView במקום חישוב ידני:
           מכבד scroll-snap ו-RTL, בלי לירות מעבר למטרה במובייל. */
        var curCard = btn.closest('.ids-ugc-card');
        var shopRow = btn.closest('.ids-ugc__shop');
        if (curCard && shopRow && !shopRow.__idsSkipAdv) {
          var nxt = curCard.nextElementSibling;
          if (nxt && nxt.classList.contains('ids-ugc-card')) {
            setTimeout(function () {
              if (shopRow.__idsSkipAdv) return;
              nxt.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
            }, 650);
          }
        }
      })
      .catch(function () {
        if (isPill) btn.classList.remove('success');
        toast('משהו השתבש, נסי שוב');
        state.busy = false;
      });
  }

  /* Warm exactly the intended thumbnail. Hover requires a short dwell; touch
     and keyboard intent start immediately. No video requests on page load. */
  var thumbWarmTimer;
  function prefetchFromThumb(thumb) {
    if (playerIsOpen() || limitedConnection()) return;
    var player = playerOf(thumb);
    if (!player) return;
    var idx = parseInt(thumb.getAttribute('data-ids-ugc-open'), 10) || 0;
    var slide = slidesOf(player).filter(function (s) { return !s.hasAttribute('data-ids-ugc-injected'); })[idx];
    if (slide) warmSlide(slide);
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !(e.target instanceof Element)) return;
    var thumb = e.target.closest('[data-ids-ugc-open]');
    if (!thumb || (e.relatedTarget && thumb.contains(e.relatedTarget))) return;
    clearTimeout(thumbWarmTimer);
    thumbWarmTimer = setTimeout(function () { prefetchFromThumb(thumb); }, 120);
  }, { passive: true });
  document.addEventListener('pointerout', function (e) {
    if (!(e.target instanceof Element)) return;
    var thumb = e.target.closest('[data-ids-ugc-open]');
    if (thumb && (!e.relatedTarget || !thumb.contains(e.relatedTarget))) clearTimeout(thumbWarmTimer);
  }, { passive: true });
  ['pointerdown', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!(e.target instanceof Element)) return;
      var thumb = e.target.closest('[data-ids-ugc-open]');
      if (thumb) { clearTimeout(thumbWarmTimer); prefetchFromThumb(thumb); }
    }, { passive: true });
  });

  /* ───────── האזנות — delegation אחד לכל הדף ───────── */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    /* קליק שמגיע מיד אחרי גרירת כרטיסים — לא לחיצה אמיתית */
    if (t.closest('.ids-ugc__shop') && Date.now() - (window.__idsUgcDragTs || 0) < 350) return;

    var open = t.closest('[data-ids-ugc-open]');
    if (open) {
      var player = playerOf(open);
      if (player) openPlayer(player, parseInt(open.getAttribute('data-ids-ugc-open'), 10) || 0);
      return;
    }

    /* IDS 3.11.2026: בורר אורך בכרטיס (SHORT · REGULAR · TALL) — מחליף את שורת המידות המוצגת, בלי הוספה לסל */
    var len = t.closest('[data-ids-ugc-len]');
    if (len) {
      var lcard = len.closest('.ids-ugc-card');
      if (lcard) {
        var lv = len.getAttribute('data-ids-ugc-len');
        [].forEach.call(lcard.querySelectorAll('[data-ids-ugc-len]'), function (b) {
          var on = b === len;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        [].forEach.call(lcard.querySelectorAll('[data-ids-ugc-len-group]'), function (g) {
          g.hidden = g.getAttribute('data-ids-ugc-len-group') !== lv;
        });
      }
      return;
    }

    var add = t.closest('[data-ids-ugc-add]');
    if (add && !add.disabled && !add.classList.contains('soldout')) {
      addFromPlayer(add);
      return;
    }

    /* מעקב ייחוס: לחיצה על קישור בכרטיס מוצר בתוך הנגן —
       נרשם card_click והניווט לעמוד המוצר ממשיך כרגיל. */
    var cardLink = t.closest('.ids-ugc-card a[href]');
    if (cardLink && cardLink.closest('[data-ids-ugc-player]')) {
      var cardInfo = slideTrackInfo(cardLink.closest('[data-ids-ugc-slide]'));
      var cardHandle = handleFromHref(cardLink.getAttribute('href'));
      if (cardHandle) cardInfo.product = cardHandle;
      track('card_click', cardInfo);
      return;
    }

    /* סיום מסלייד הסיכום — סגירה מלאה מיידית (בלי בועה) + פתיחת הסל */
    var fin = t.closest('[data-ids-ugc-finish]');
    if (fin) {
      var pf = fin.closest('[data-ids-ugc-player]');
      if (pf) reallyClose(pf);
      return;
    }

    /* בועת PiP: ✕ = סגירה סופית לסשן; כל טאפ אחר = חזרה לנגן מלא */
    var pipPlayer = t.closest('[data-ids-ugc-player].ids-ugc--pip');
    if (pipPlayer) {
      if (t.closest('[data-ids-ugc-pipx]')) {
        try { sessionStorage.setItem('idsUgcPipOff', '1'); } catch (err) {}
        reallyClose(pipPlayer);
      } else {
        pipPlayer.classList.remove('ids-ugc--pip');
        document.documentElement.classList.add('ids-ugc-lock');
        /* טאפ הוא מחווה אמיתית — הסאונד חוזר */
        var pv = null;
        pipPlayer.querySelectorAll('video').forEach(function (x) { if (!x.paused) pv = x; });
        if (pv && !state.muted) { pv.muted = false; pipPlayer.setAttribute('data-muted', '0'); }
      }
      return;
    }

    var close = t.closest('[data-ids-ugc-close]');
    if (close) {
      var p1 = close.closest('[data-ids-ugc-player]');
      if (p1) closePlayer(p1);
      return;
    }

    var mute = t.closest('[data-ids-ugc-mute]');
    if (mute) {
      var p2 = mute.closest('[data-ids-ugc-player]');
      if (!p2) return;
      /* מסתנכרן עם המצב בפועל: אם הסאונד הושתק אוטומטית ע"י הדפדפן,
         הכפתור מציג מושתק — לחיצה מחזירה סאונד, לא ההפך */
      var curMuted = p2.getAttribute('data-muted') === '1';
      state.muted = !curMuted;
      p2.setAttribute('data-muted', state.muted ? '1' : '0');
      p2.querySelectorAll('video').forEach(function (v) { v.muted = state.muted; });
      return;
    }

    var prev = t.closest('[data-ids-ugc-prev]');
    if (prev) { stepSlide(prev.closest('[data-ids-ugc-player]'), -1); return; }
    var next = t.closest('[data-ids-ugc-next]');
    if (next) { stepSlide(next.closest('[data-ids-ugc-player]'), 1); return; }
  });

  document.addEventListener('keydown', function (e) {
    var openPlayerEl = document.querySelector('[data-ids-ugc-player]:not([hidden])');
    if (!openPlayerEl) return;
    if (e.key === 'Escape') { closePlayer(openPlayerEl); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); stepSlide(openPlayerEl, 1); return; }
    if (e.key === 'ArrowUp') { e.preventDefault(); stepSlide(openPlayerEl, -1); return; }
  });
})();

/* ===== Inner Dragon · UGC · חיווי גלילה עדין (מובייל) · v6 =====
 * תוספת עצמאית. כשנפתח נגן עם יותר מסרטון אחד במובייל — מציג חץ
 * קטן שקופץ בעדינות, נעלם מעצמו אחרי ~9ש' או מיד כשגוללים. */
(function () {
  'use strict';
  var isMobile = function () { return window.matchMedia('(max-width: 767px)').matches; };
  var CUE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 14l5-5 5 5"/></svg><span>החליקי למעלה לסרטון הבא</span>';

  function hideCue(player) {
    if (player.__idsCue) player.__idsCue.classList.remove('is-show');
  }

  function showCue(player) {
    if (!isMobile()) return;
    var feed = player.querySelector('[data-ids-ugc-feed]');
    var slides = player.querySelectorAll('[data-ids-ugc-slide]');
    if (!feed || slides.length < 2) return; /* סרטון יחיד — אין לאן לגלול */

    var cue = player.__idsCue;
    if (!cue) {
      var stage = player.querySelector('.ids-ugc__stage') || player;
      cue = document.createElement('div');
      cue.className = 'ids-ugc__scrollcue';
      cue.setAttribute('aria-hidden', 'true');
      cue.innerHTML = CUE_SVG;
      stage.appendChild(cue);
      player.__idsCue = cue;
      feed.addEventListener('scroll', function () { hideCue(player); }, { passive: true });
    }
    cue.classList.remove('is-show');
    void cue.offsetWidth; /* reflow — מפעיל את האנימציה מחדש */
    cue.classList.add('is-show');
    clearTimeout(player.__idsCueT);
    player.__idsCueT = setTimeout(function () { hideCue(player); }, 9000);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-ids-ugc-open]')) return;
    setTimeout(function () {
      var player = document.querySelector('[data-ids-ugc-player]:not([hidden])');
      if (player) showCue(player);
    }, 360);
  });
})();

/* ===== Inner Dragon · UGC · חץ מעבר בין כרטיסי מוצרים · v6 =====
 * תוספת עצמאית. כשלסרטון מתויגים כמה מוצרים, מופיע חץ עגול קטן
 * על קצה רצועת הכרטיסים: לחיצה מקדמת לכרטיס הבא; בסוף הרשימה
 * החץ מתהפך ומחזיר להתחלה. עובד בדסקטופ ובמובייל. */
(function () {
  'use strict';

  function ensureShopNav(slide) {
    var shop = slide.querySelector('.ids-ugc__shop');
    if (!shop || shop.__idsNavDone) return;
    shop.__idsNavDone = true;
    /* מוצר אחד או שאין גלישה — אין צורך בחץ */
    if (shop.scrollWidth <= shop.clientWidth + 4) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ids-ugc__shopnav';
    btn.setAttribute('aria-label', 'למוצר הבא בסרטון');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="13" height="13"><path d="M14.5 5L8 12l6.5 7"/></svg>';
    slide.appendChild(btn);

    function st() {
      var max = shop.scrollWidth - shop.clientWidth;
      var pos = Math.abs(shop.scrollLeft);
      btn.classList.toggle('is-back', pos >= max - 6);
    }
    btn.addEventListener('click', function (ev) {
      ev.stopPropagation();
      var max = shop.scrollWidth - shop.clientWidth;
      var pos = Math.abs(shop.scrollLeft);
      if (pos >= max - 6) {
        shop.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        shop.scrollBy({ left: -shop.clientWidth * 0.85, behavior: 'smooth' });
      }
    });
    shop.addEventListener('scroll', function () { requestAnimationFrame(st); }, { passive: true });
    st();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-ids-ugc-open]')) return;
    setTimeout(function () {
      var p = document.querySelector('[data-ids-ugc-player]:not([hidden])');
      if (p) {
        p.querySelectorAll('[data-ids-ugc-slide]').forEach(ensureShopNav);
      }
    }, 400);
  });
})();

/* ===== Inner Dragon · UGC · נקודות התקדמות בנגן · v6 =====
 * תוספת עצמאית. פסי-נקודות בסטייל סטוריז בצד הנגן: רואים כמה
 * סרטונים יש ואיפה נמצאים — האיתות המוכר ל"יש עוד, אפשר להחליק".
 * נבנה בפתיחת הנגן, מתעדכן בכל גלילה. pointer-events:none. */
(function () {
  'use strict';

  function buildDots(player) {
    if (player.__idsDots) return;
    var slides = player.querySelectorAll('[data-ids-ugc-slide]');
    if (slides.length < 2) return;
    var stage = player.querySelector('.ids-ugc__stage') || player;
    var feed = player.querySelector('[data-ids-ugc-feed]');
    if (!feed) return;
    var wrap = document.createElement('div');
    wrap.className = 'ids-ugc__dots';
    wrap.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < slides.length; i++) {
      wrap.appendChild(document.createElement('span'));
    }
    stage.appendChild(wrap);
    player.__idsDots = wrap;
    function upd() {
      var idx = Math.round(feed.scrollTop / Math.max(1, feed.clientHeight));
      [].forEach.call(wrap.children, function (c, i) {
        c.classList.toggle('is-on', i === idx);
      });
    }
    feed.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    upd();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-ids-ugc-open]')) return;
    setTimeout(function () {
      var p = document.querySelector('[data-ids-ugc-player]:not([hidden])');
      if (p) buildDots(p);
    }, 380);
  });
})();

/* ===== upsell צבע-אחות בנגן · v7.3 =====
   v7.3 (תיקוני שטח): חימום הסלייד המוזרק (פוסטר+metadata) — סוף
   למסך שחור עם סאונד; ביטול הקידום האופקי כשמתוזמן מעבר סרטון
   (אין שתי גלילות מתנגשות); הגלייד מוותר אם הלקוחה גללה בעצמה;
   סלייד מוזרק לא מזיז את אינדקסי הממוזערים; escape לגרש ב-data-sibs
   (נעשה בצד ה-Liquid) — מוצרים כמו ג'ינג'ית כבר לא שוברים את ה-JSON.
   ====================================
   כשהלקוחה סיימה להוסיף את *כל* המוצרים שבסרטון, מוצע לה אותו
   דגם בצבע נוסף — באותה מידה שכבר בחרה. סדר עדיפות:

   1) הצבע כבר מופיע בסרטון אחר בפיד → מחליקים אליו.
   2) לצבע יש סרטון משלו (מהמטאפילד ugc_videos שלו, מוטמע ע"י
      ids-ugc-product-card) → מזריקים סלייד וידאו חדש מיד אחרי
      הסרטון הנוכחי ומחליקים אליו. ההצעה מוצגת בווידאו — על גוף
      אמיתי — עם כרטיס שבו המידה שלה מודגשת. טאפ אחד = בסל.
   3) אין וידאו בכלל → כרטיס הצעה בסוף רצועת המוצרים הנוכחית.

   בחירת הצבע: מהפריט האחרון שנוסף אחורה, לפי סדר הצבעים בקבוצת
   הדגם (custom.color_variants_group), רק צבע שהמידה שנבחרה קיימת
   בו במלאי ושאינו כבר בסרטון. מופיע פעם אחת לסרטון. */
(function () {
  'use strict';

  /* זיכרון סשן: כל מה שנוסף מהנגן, handle→מידה. משמש לסימון
     "כבר בסל" בסרטונים אחרים ולדילוג ישיר ל-upsell בלי כפילויות */
  var addedMap = {};
  window.__idsUgcAdded = addedMap; /* סלייד הסיכום קורא מכאן */

  function realCards(shop) {
    return [].filter.call(shop.querySelectorAll('.ids-ugc-card'), function (c) {
      return !c.classList.contains('ids-ugc-upsell');
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function feedOf(player) {
    return player ? player.querySelector('[data-ids-ugc-feed]') : null;
  }

  function slideIndex(player, slide) {
    return [].indexOf.call(player.querySelectorAll('[data-ids-ugc-slide]'), slide);
  }

  /* גלילת הפיד לסלייד — רגוע ומכבד את הלקוחה:
     • ממתין 1.5 שניות אחרי ה-✓ (שהטוסט ינשום)
     • מוותר אם היא גללה בעצמה בינתיים — לא חוטפים לה את הפיד
     • מוודא הגעה: snap mandatory לפעמים בולע גלילה חלקה —
       אם לא הגענו, קפיצה ישירה לסלייד */
  function glideToSlide(player, slide, shop) {
    var feed = feedOf(player);
    if (!feed) return;
    if (shop) shop.__idsSkipAdv = true; /* מבטל את הקידום האופקי המתחרה */
    var startTop = feed.scrollTop;
    setTimeout(function () {
      if (player.hasAttribute('hidden')) return;
      if (Math.abs(feed.scrollTop - startTop) > 40) return; /* גללה בעצמה */
      var idx = slideIndex(player, slide);
      if (idx < 0) return;
      var top = idx * feed.clientHeight;
      feed.scrollTo({ top: top, behavior: 'smooth' });
      setTimeout(function () {
        if (player.hasAttribute('hidden')) return;
        var near = Math.abs(feed.scrollTop - top) <= 40;
        /* קפיצה ישירה רק אם הגלילה החלקה נבלעה (עוד ליד ההתחלה) —
           אם הלקוחה גללה בעצמה למקום אחר, מכבדים אותה */
        if (!near && Math.abs(feed.scrollTop - startTop) < 40) {
          slide.scrollIntoView({ behavior: 'auto', block: 'start' });
          near = true;
        }
        /* הגענו — מפעילים במפורש: הקודם נעצר, החדש מתנגן עם סאונד */
        if (near && window.__idsUgcActivateSlide) window.__idsUgcActivateSlide(slide);
      }, 1100);
    }, 1500);
  }

  /* IDS 3.11.2026: התאמת גלולת מידה למידה שנשמרה — תומך גם ב-"M / REGULAR"
     (מוצר מידה+אורך): הגלולה "M" בקבוצת האורך REGULAR נחשבת התאמה */
  function pillMatches(pill, size) {
    if (!size) return false;
    var txt = (pill.textContent || '').trim();
    if (txt === size) return true;
    var at = size.indexOf(' / ');
    if (at === -1) return false;
    var g = pill.closest('[data-ids-ugc-len-group]');
    return txt === size.slice(0, at) && (!g || g.getAttribute('data-ids-ugc-len-group') === size.slice(at + 3));
  }

  /* שורת ההקשר + הדגשת המידה שלה על כרטיס יעד */
  function markYours(card, size) {
    if (!card.querySelector('.ids-ugc-card__yours')) {
      var hint = document.createElement('p');
      hint.className = 'ids-ugc-card__yours';
      hint.textContent = size ? 'הדגם שהוספת — בצבע הזה · המידה שלך ' + size.replace(' / ', ' · ') : 'הדגם שהוספת — בצבע הזה';
      var info = card.querySelector('.ids-ugc-card__info');
      if (info) info.insertBefore(hint, info.firstChild);
    }
    if (size) {
      [].forEach.call(card.querySelectorAll('.pcard-size-btn'), function (p) {
        if (pillMatches(p, size)) p.classList.add('is-yours');
      });
    }
  }

  /* מחפש בסליידים האחרים סרטון שמופיע בו המוצר (לפי handle) */
  function slideOfHandle(player, curSlide, handle) {
    if (!player || !handle) return null;
    var slides = player.querySelectorAll('[data-ids-ugc-slide]');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i] === curSlide) continue;
      var c = slides[i].querySelector('.ids-ugc-card[data-handle="' + handle + '"]');
      if (c) return { slide: slides[i], card: c };
    }
    return null;
  }

  /* מסלול 2: הזרקת סלייד וידאו של הצבע המוצע, מיד אחרי הנוכחי.
     הסלייד בנוי בדיוק כמו סלייד Liquid — ה-JS הראשי כבר יודע
     לנגן אותו (data-video-src/hls/poster + holder). */
  function injectColorSlide(player, curSlide, cand, shop) {
    var feed = feedOf(player);
    if (!feed || !curSlide) return false;
    var sib = cand.sib, size = cand.size;

    var sizesHtml = '';
    var ks = Object.keys(sib.vs || {});
    /* IDS 3.11.2026: מוצר מידה+אורך — מציגים רק את המידות של האורך שנבחר (לא 15 גלולות) */
    var lenAt = size ? size.indexOf(' / ') : -1;
    var lenSuffix = lenAt > -1 ? size.slice(lenAt) : '';
    for (var i = 0; i < ks.length; i++) {
      var kAt = ks[i].indexOf(' / ');
      if (lenSuffix && kAt > -1 && ks[i].slice(kAt) !== lenSuffix) continue;
      var kLabel = lenSuffix && kAt > -1 ? ks[i].slice(0, kAt) : ks[i];
      sizesHtml += '<button class="pcard-size-btn ids-ugc-card__size' + (ks[i] === size ? ' is-yours' : '') + '" type="button" data-ids-ugc-add data-variant-id="' + esc(sib.vs[ks[i]]) + '">' + esc(kLabel) + '</button>';
    }

    var slide = document.createElement('div');
    slide.className = 'ids-ugc__slide';
    slide.setAttribute('data-ids-ugc-slide', '');
    slide.setAttribute('data-ids-ugc-injected', '1'); /* לא מזיז אינדקסי ממוזערים */
    slide.setAttribute('data-video-src', sib.vu);
    if (sib.vh) slide.setAttribute('data-video-hls', sib.vh);
    if (sib.vl) slide.setAttribute('data-video-low', sib.vl);
    if (sib.vp) slide.setAttribute('data-poster', sib.vp);
    slide.innerHTML =
      '<div class="ids-ugc__holder" data-ids-ugc-holder></div>' +
      (sib.ms ? '<span class="ids-ugc__sizetag">מידות בסרטון: ' + esc(sib.ms) + '</span>' : '') +
      '<div class="ids-ugc__shop">' +
        '<div class="ids-ugc-card" data-handle="' + esc(sib.h) + '">' +
          '<a class="ids-ugc-card__media" href="/products/' + esc(sib.h) + '" tabindex="-1" aria-hidden="true">' +
            '<img src="' + esc(sib.img) + '" alt="" loading="lazy" width="66" height="88">' +
          '</a>' +
          '<div class="ids-ugc-card__info">' +
            '<p class="ids-ugc-card__yours">' + (size ? 'הדגם שהוספת — בצבע הזה · המידה שלך ' + esc(size.replace(' / ', ' · ')) : 'הדגם שהוספת — בצבע הזה') + '</p>' +
            '<p class="ids-ugc-card__title"><a href="/products/' + esc(sib.h) + '">' + esc(sib.t || sib.c) + '</a></p>' +
            (sib.pr ? '<p class="ids-ugc-card__price">' + esc(sib.pr) + '</p>' : '') +
            '<div class="ids-ugc-card__sizes">' + sizesHtml + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    curSlide.parentNode.insertBefore(slide, curSlide.nextSibling);
    if (window.__idsUgcObserveSlide) window.__idsUgcObserveSlide(slide);

    /* נקודת התקדמות חדשה במיקום הנכון */
    var dots = player.__idsDots;
    if (dots) {
      var nIdx = slideIndex(player, slide);
      dots.insertBefore(document.createElement('span'), dots.children[nIdx] || null);
    }

    glideToSlide(player, slide, shop);
    return true;
  }

  /* מסלול 3: כרטיס הצעה בסוף רצועת הסרטון הנוכחי */
  function inlineUpsellCard(shop, cand) {
    var sib = cand.sib, size = cand.size;
    var el = document.createElement('div');
    el.className = 'ids-ugc-card ids-ugc-upsell';
    el.innerHTML =
      '<a class="ids-ugc-card__media" href="/products/' + esc(sib.h) + '" tabindex="-1" aria-hidden="true">' +
        '<img src="' + esc(sib.img) + '" alt="" loading="lazy" width="66" height="88">' +
      '</a>' +
      '<div class="ids-ugc-card__info">' +
        '<p class="ids-ugc-card__title">יש את הדגם גם ב־' + esc(sib.c) + '</p>' +
        '<p class="ids-ugc-card__price">' + (size ? 'באותה מידה שבחרת · ' + esc(size) : 'בקליק אחד') + '</p>' +
        '<div class="ids-ugc-upsell__btns">' +
          '<button type="button" class="ids-ugc-card__atc ids-ugc-upsell__yes" data-ids-ugc-add data-variant-id="' + esc(cand.vid) + '">הוסיפי גם</button>' +
          '<button type="button" class="ids-ugc-upsell__no">לא תודה</button>' +
        '</div>' +
      '</div>';
    shop.appendChild(el);
    /* בלי גלילה משלנו — הכרטיס נוסף לפני שהקידום האופקי הגנרי רץ
       (האירוע נשלח לפניו), והוא זה שגולל אליו. מנגנון גלילה אחד. */
  }

  document.addEventListener('ids-ugc:atc', function (e) {
    var btn = e.detail && e.detail.btn;
    if (!btn) return;
    var card = btn.closest('.ids-ugc-card');
    var shop = btn.closest('.ids-ugc__shop');
    if (!card || !shop) return;

    /* הוספה מכרטיס ה-upsell עצמו — לנקות כפתורים ולסיים */
    if (card.classList.contains('ids-ugc-upsell')) {
      var no = card.querySelector('.ids-ugc-upsell__no');
      if (no) no.remove();
      return;
    }

    card.classList.add('is-added');
    if (btn.classList.contains('pcard-size-btn')) {
      /* IDS 3.11.2026: מוצר מידה+אורך — נשמר כ-"M / REGULAR" (מפתח ה-vs של צבעי-האחות) */
      var lenGrp = btn.closest('[data-ids-ugc-len-group]');
      card.dataset.addedSize = (btn.textContent || '').trim() + (lenGrp ? ' / ' + lenGrp.getAttribute('data-ids-ugc-len-group') : '');
    }
    var ch = card.getAttribute('data-handle');
    if (ch) {
      var im = card.querySelector('.ids-ugc-card__media img');
      var tt = card.querySelector('.ids-ugc-card__title');
      addedMap[ch] = {
        s: (card.dataset.addedSize || '').trim(),
        img: im ? im.src : '',
        t: tt ? (tt.textContent || '').trim() : ''
      };
    }

    /* השלמת הסט: האם הפריט הזה בעצמו סומן כמשלים של פריט קודם? */
    var completedSet = ch && window.__idsUgcWanted && window.__idsUgcWanted[ch];
    /* המשלימים של מה שנוסף עכשיו → ראש התור */
    var cmpRaw = card.getAttribute('data-cmp');
    if (cmpRaw && window.__idsUgcWantCmp) {
      var cmpArr = null;
      try { cmpArr = JSON.parse(cmpRaw); } catch (err2) {}
      var pl0 = shop.closest('[data-ids-ugc-player]');
      if (cmpArr && cmpArr.length && pl0) window.__idsUgcWantCmp(pl0, cmpArr);
    }
    if (completedSet && window.__idsUgcSetDone) {
      var pl1 = shop.closest('[data-ids-ugc-player]');
      var sl1 = shop.closest('[data-ids-ugc-slide]');
      if (pl1 && sl1) {
        window.__idsUgcSetDone(pl1, sl1);
        return; /* רגע הסיכום — בלי upsell מתחרה באותה נשימה */
      }
    }

    /* מציעים רק כשכל מוצרי הסרטון כבר בסל — שיא האמון, אפס עומס */
    var all = realCards(shop);
    var done = all.every(function (c) { return c.classList.contains('is-added'); });
    if (!done) return;
    maybeUpsell(shop, all);
  });

  /* לב ההצעה — נקרא גם אחרי הוספה, וגם כשמגיעים לסרטון שכל
     המוצרים שלו כבר בסל (כפילויות בין סרטונים) */
  function maybeUpsell(shop, all) {
    if (shop.querySelector('.ids-ugc-upsell') || shop.__idsUpsellDone) return;

    var player = shop.closest('[data-ids-ugc-player]');
    var curSlide = shop.closest('[data-ids-ugc-slide]');
    var handles = all.map(function (c) { return c.getAttribute('data-handle') || ''; });

    /* איסוף מועמדים: מהפריט האחרון שנוסף אחורה, צבע-אחות שאינו
       כבר בסרטון הזה ושהמידה שנבחרה קיימת בו במלאי */
    var candidates = [];
    for (var i = all.length - 1; i >= 0; i--) {
      var c = all[i];
      var raw = c.getAttribute('data-sibs');
      if (!raw) continue;
      var sibs;
      try { sibs = JSON.parse(raw); } catch (err) { continue; }
      var s = (c.dataset.addedSize || '').trim();
      for (var j = 0; j < sibs.length; j++) {
        var sb = sibs[j];
        if (!sb || !sb.vs || handles.indexOf(sb.h) !== -1) continue;
        if (addedMap.hasOwnProperty(sb.h)) continue; /* כבר בסל — לא מציעים שוב */
        var keys = Object.keys(sb.vs);
        if (!keys.length) continue;
        var vid = s ? sb.vs[s] : sb.vs[keys[0]];
        if (!vid) continue;
        candidates.push({ sib: sb, vid: vid, size: s });
      }
    }
    if (!candidates.length) return;

    var k, hit;

    /* עדיפות 1: הצבע כבר מופיע בסרטון אחר בפיד — מחליקים אליו */
    for (k = 0; k < candidates.length; k++) {
      hit = slideOfHandle(player, curSlide, candidates[k].sib.h);
      if (hit) {
        shop.__idsUpsellDone = true;
        markYours(hit.card, candidates[k].size);
        glideToSlide(player, hit.slide, shop);
        return;
      }
    }

    /* עדיפות 2: לצבע יש סרטון משלו — מזריקים אותו לפיד */
    for (k = 0; k < candidates.length; k++) {
      if (candidates[k].sib.vu && player && curSlide) {
        shop.__idsUpsellDone = true;
        if (injectColorSlide(player, curSlide, candidates[k], shop)) return;
        break;
      }
    }

    /* עדיפות 3: אין וידאו — כרטיס הצעה ברצועה הנוכחית */
    shop.__idsUpsellDone = true;
    inlineUpsellCard(shop, candidates[0]);
  }

  /* הגעה לסרטון שמציג מוצרים שכבר נוספו: מסמנים "כבר בסל ✓"
     (בלי לבלבל עם כפילויות), ואם הכל כבר בסל — ישר ל-upsell */
  document.addEventListener('ids-ugc:slide', function (e) {
    var slide = e.detail && e.detail.slide;
    if (!slide) return;
    var shop = slide.querySelector('.ids-ugc__shop');
    if (!shop) return;
    var all = realCards(shop);
    if (!all.length) return;

    /* מיקוד הרצועה: אם בסרטון יש מוצרים שכבר בסל, הרצועה נפתחת
       על הכרטיס הרלוונטי — קודם המשלים המסומן, אחרת הראשון שעוד
       לא נוסף — ולא על כפילות של מה שהיא כבר קנתה */
    if (!shop.__idsFocused) {
      var anyAdded = false, firstFree = null, wantedCard = null;
      all.forEach(function (c) {
        var hh = c.getAttribute('data-handle') || '';
        if (addedMap.hasOwnProperty(hh)) { anyAdded = true; return; }
        if (!firstFree) firstFree = c;
        if (!wantedCard && window.__idsUgcWanted && window.__idsUgcWanted[hh]) wantedCard = c;
      });
      var focusTgt = wantedCard || firstFree;
      if (anyAdded && focusTgt) {
        shop.__idsFocused = true;
        setTimeout(function () {
          focusTgt.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }, 500);
      }
    }

    var changed = false;
    /* הכוונת עין: בסרטון מרובה מוצרים, הכרטיס שמשלים את מה
       שכבר נוסף מקבל שורת הקשר — העין הולכת ישר אליו */
    all.forEach(function (c) {
      var h = c.getAttribute('data-handle');
      if (!h || c.classList.contains('is-added')) return;
      if (!window.__idsUgcWanted || !window.__idsUgcWanted[h]) return;
      if (addedMap.hasOwnProperty(h) || c.querySelector('.ids-ugc-card__cmp')) return;
      var m = document.createElement('p');
      m.className = 'ids-ugc-card__cmp';
      m.textContent = 'משלים את הפריט שהוספת';
      var inf = c.querySelector('.ids-ugc-card__info');
      if (inf) inf.insertBefore(m, inf.firstChild);
    });
    all.forEach(function (c) {
      var h = c.getAttribute('data-handle');
      if (!h || !addedMap.hasOwnProperty(h) || c.classList.contains('is-added')) return;
      c.classList.add('is-added');
      var s = (addedMap[h] && addedMap[h].s) || '';
      c.dataset.addedSize = s;
      if (s) {
        [].forEach.call(c.querySelectorAll('.pcard-size-btn'), function (pl) {
          if (pillMatches(pl, s)) pl.classList.add('success');
        });
      }
      if (!c.querySelector('.ids-ugc-card__inbag')) {
        var b = document.createElement('p');
        b.className = 'ids-ugc-card__inbag';
        b.textContent = 'כבר בסל ✓';
        var info = c.querySelector('.ids-ugc-card__info');
        if (info) info.insertBefore(b, info.firstChild);
      }
      changed = true;
    });
    if (!changed) return;
    if (all.every(function (c) { return c.classList.contains('is-added'); })) {
      maybeUpsell(shop, all);
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var no = e.target.closest('.ids-ugc-upsell__no');
    if (!no) return;
    var c = no.closest('.ids-ugc-upsell');
    if (c) c.remove();
  });
})();


} /* ═══ סוף שריון טעינה כפולה ═══ */
